/* ========================================================================
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    className: 'll-quoter',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const _this = this;
      const startPage = $( `.${_this.className}` ).data( 'quoter-start' );

      $( '.quoter-skin__btn-prev' ).on( 'click', function() {
        location.href = startPage;
      } );

      if ( $( '.ll-quoter' ).length ) {
        $( document ).on( 'click', 'div', function() {
          /* check if it's a radio button group and if there are 2 or less fields (radio buton field and section field) */
          if ( $( this ).parent().hasClass( 'gfield_radio' ) && $( this ).parents( '.gform_fields' ).children().length < 3 ) {
            $( this ).find( 'input[type="radio"]' ).prop( 'checked', true );
            $( this ).siblings().find( 'input[type="radio"]' ).prop( 'checked', false );
            $( this ).parents( '.gform_page' ).find( '.gform_page_footer' ).find( '.gform_next_button' ).trigger( 'click' );
          }
        } );

        if ( $( '.llgq-current-page' ).find( '.gfield_radio' ).length > 0 && $( '.llgq-current-page' ).find( '.gform_fields' ).children().length < 3 ) {
          $( '.llgq-current-page' ).find( '.gform_page_footer ' ).addClass( 'sr-only' );
        }
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const curFormPage = $( '#gform_page_' + formId + '_' + currentPage );

        if ( currentPage === 1 ) {
          $( '.quoter-skin__btn-prev' ).on( 'click', function() {
            location.href = startPage;
          } );
        } else if ( currentPage !== '1' ) {
          $( '.quoter-skin__btn-prev' ).on( 'click', function() {
            curFormPage.find( '.gform_previous_button' ).trigger( 'click' );
          } );
        }

        if ( curFormPage.find( '.gform_fields' ).children().length > 2 || curFormPage.find( '.ll_gfield_type_radio' ).length < 1 ) {
          curFormPage.find( '.gform_page_footer ' ).removeClass( 'sr-only' );
        } else {
          curFormPage.find( '.gform_page_footer ' ).addClass( 'sr-only' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-quoter', COMPONENT );
} )( app );

